import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "close" }, "×", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { controls: "" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Votre navigateur ne prend pas en charge la vidéo HTML. ")
const _hoisted_11 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "header", {}, () => [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }, _hoisted_6)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "body", {}, () => [
                _createElementVNode("video", _hoisted_8, [
                  _createElementVNode("source", {
                    src: $options.videoUrl,
                    type: "video/mp4"
                  }, null, 8, _hoisted_9),
                  _hoisted_10
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _renderSlot(_ctx.$slots, "footer")
            ])
          ])
        ])
      ])
    ]),
    _: 3
  }))
}